/*
 * <quick-buy-gallery>
 *
 * Lives in its own asset, not in the section's {% javascript %}: Shopify only
 * bundles the JS of sections RENDERED on the page (see the `data-sections`
 * attribute on compiled_assets/scripts.js). A section fetched through the
 * Section Rendering API is never in that list, so the element would never be
 * defined and the chevrons would do nothing.
 */
if (!customElements.get('quick-buy-gallery')) {
  customElements.define(
    'quick-buy-gallery',
    class QuickBuyGallery extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.nav = this.querySelector('[data-nav]');
        if (this.slides.length < 2) return;
        if (!this.nav) return;

        this.counter = this.querySelector('[data-counter-current]');
        this.counterLabel = this.querySelector('[data-counter-label]');
        this.labelTemplate = this.counterLabel ? this.counterLabel.textContent.trim() : '';
        this.index = 0;

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
        if (next) next.addEventListener('click', () => this.goTo(this.index + 1));

        // Écouté sur la galerie entière, pas sur le compteur : les chevrons ont
        // quitté `[data-nav]` pour se poser sur l'image, et c'est eux qui
        // prennent le focus clavier.
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.index + 1);
          }
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index - 1);
          }
        });
      }

      goTo(next) {
        const total = this.slides.length;
        // Safe modulo so the chevrons wrap at both ends.
        const target = ((next % total) + total) % total;
        this.index = target;

        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === target));

        if (this.counter) {
          this.counter.textContent = String(target + 1).padStart(2, '0');
        }
        if (this.counterLabel && this.labelTemplate) {
          // The rendered label already carries the position 1 wording; swap the
          // leading number rather than rebuilding the sentence, so it stays
          // translated whatever the locale.
          this.counterLabel.textContent = this.labelTemplate.replace(
            /\d+/,
            String(target + 1)
          );
        }
      }
    }
  );
}
